import { useState } from 'react';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../../lib/firebase';

const useRegisterAccount = () => {
  const [error, setError] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [user, setUser] = useState(null);

  const register = async ({ email, password, firstName, lastName }) => {
    setIsRegistering(true);
    setError(null);

    try {
      // Create the Firebase Auth user
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const registeredUser = userCredential.user;

      // Update display name for Firebase Auth
      await updateProfile(registeredUser, {
        displayName: `${firstName} ${lastName}`
      });

      // Create user document in Firestore
      const userDocRef = doc(db, 'users', registeredUser.uid);
      await setDoc(userDocRef, {
        access_level: 'user',
        email,
        first_name: firstName,
        last_name: lastName,
        password_updated: serverTimestamp(),
        created_at: serverTimestamp(),
        updated_at: serverTimestamp()
      });

      setUser(registeredUser);
    } catch (err) {
      console.error('Registration Error:', err);
      setError(err.message);
    } finally {
      setIsRegistering(false);
    }
  };

  return {
    register,
    user,
    isRegistering,
    error,
  };
};

export default useRegisterAccount;
